import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChartLineRegularReport from './chart-line-regular-report-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChartLineRegularReport {...validProps} />;
}

SvgComponent.iconName = 'chartLineRegularReport';

export const ChartLineRegularReportIcon = svgIconWrapper(SvgComponent);
